import { render, staticRenderFns } from "./GameScreenFieldSingle.vue?vue&type=template&id=39dbee35&"
import script from "./GameScreenFieldSingle.vue?vue&type=script&lang=js&"
export * from "./GameScreenFieldSingle.vue?vue&type=script&lang=js&"
import style0 from "./GameScreenFieldSingle.vue?vue&type=style&index=0&id=39dbee35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports